import styled from 'styled-components';

interface SubTabsProps {
  active: boolean;
}

export const SubTab = styled.div<SubTabsProps>`
  width: fit-content;
  padding: 2px 24px;
  margin: 23px 0 14px 0;
  text-align: center;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-size: 13px;
  font-weight: 500;
  border-right: 1px solid
    ${({ theme }) => theme.atlas.semantic.color.surface.variant};

  color: ${(props) =>
    props.active
      ? props.theme.atlas.semantic.color.type.default
      : props.theme.atlas.semantic.color.type.disabled};

  &:hover {
    color: ${({ theme }) => theme.atlas.semantic.color.type.muted};
  }

  &:last-child {
    border-right: none;
  }
  transition: all ease-in-out 0.3s;
`;

export const SubTabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  background: ${({ theme }) => theme.atlas.semantic.color.surface.default};
  border-radius: 8px 8px 0 0;
  padding-left: 14px;
`;
